import FlagIcon from "@mui/icons-material/Flag";
import {
  DataGridV2 as DataGrid,
  DataGridBaseBaseProps,
  DataGridModalEditColumn,
  GridColumns,
  PageHeader,
} from "common";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import { RedflagPartnerItem } from "./redflagPartnerApi";
import RedflagPartnerForm from "./RedflagPartnerForm";
import useRedflagPartnerList from "./useRedflagPartnerList";

export interface RedflagPartnerListProps
  extends Omit<DataGridBaseBaseProps, "id"> {
  showHeader?: boolean;
}

export default function RedflagPartnerList({
  showHeader = true,
  ...props
}: RedflagPartnerListProps) {
  const { params, scope, editUrl, ...service } = useRedflagPartnerList();
  const { hasPermissions, canEditItem } = useAccess();
  let columns: GridColumns<RedflagPartnerItem> = [
    {
      field: "name",
      headerName: I18n.t("RedflagPartner.attributes.name"),
      renderCell: params => (
        <DataGridModalEditColumn
          href={`${editUrl}${params.row?.id}`}
          params={params}
        />
      ),
      flex: 1,
    },
    {
      field: "reason",
      headerName: I18n.t("RedflagPartner.attributes.reason"),
      flex: 2,
    },
  ];

  return (
    <>
      {showHeader && (
        <PageHeader
          avatar={<FlagIcon color="error" />}
          title={I18n.t("RedflagPartner.title")}
        />
      )}
      <DataGrid
        {...service}
        columns={columns}
        id="redflag-partners"
        renderModalForm={props => <RedflagPartnerForm {...props} />}
        //modalProps={{ maxWidth: "md" }}
        {...props}
        canCreate={hasPermissions("partner_group.create")}
        canDelete={hasPermissions([
          "partner_group.editany",
          "partner_group.editown",
        ])}
        canEdit={hasPermissions([
          "partner_group.editany",
          "partner_group.editown",
        ])}
        canDeleteRow={params => canEditItem("partner_group", params.row)}
        canEditRow={params => canEditItem("partner_group", params.row)}
        canBatchActions={hasPermissions([
          "partner_group.editany",
          "partner_group.editown",
        ])}
        canHandleTrash={hasPermissions([
          "partner_group.editany",
          "partner_group.editown",
        ])}
      />
    </>
  );
}
